import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from 'components/Layouts/dashboard';
import WebLayout from 'components/Layouts/web';

import {
  ApplicationPaths,
  LoginActions,
  LogoutActions,
} from 'components/Auth/api-authorization/ApiAuthorizationConstants';

import { LogoutProcess } from 'components/Auth/processes/LogoutProcess';
import { Home } from 'pages/Home/Home';
import { LoginProcess } from 'components/Auth/processes/LoginProcess';
import { GoogleLogMe } from 'components/Auth/processes/GoogleLogMe';
import CookieBanner from 'components/CookieBanner/CookieBanner';

const Planoo = lazy(() =>
  import('pages/Planoo/Planoo').then((module) => ({ default: module.Planoo })),
);
const About = lazy(() =>
  import('pages/About/About').then((module) => ({ default: module.About })),
);
const HowItWorks = lazy(() =>
  import('./pages/HowItWorks/HowItWorks').then((module) => ({
    default: module.HowItWorks,
  })),
);
const Contact = lazy(() =>
  import('./pages/Contact/Contact').then((module) => ({
    default: module.Contact,
  })),
);

const App: React.FC = () => {
  return (
    <BrowserRouter
      future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
    >
      <Suspense
        fallback={
          <div
            style={{
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Loading...
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<WebLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="how-it-works" element={<HowItWorks />} />
            <Route
              path={ApplicationPaths.Login}
              element={<LoginProcess action={LoginActions.Login} />}
            />
            <Route
              path={ApplicationPaths.LoginFailed}
              element={<LoginProcess action={LoginActions.LoginFailed} />}
            />
            <Route
              path={ApplicationPaths.LoginCallback}
              element={<LoginProcess action={LoginActions.LoginCallback} />}
            />
            <Route
              path={ApplicationPaths.Profile}
              element={<LoginProcess action={LoginActions.Profile} />}
            />
            <Route
              path={ApplicationPaths.Register}
              element={<LoginProcess action={LoginActions.Register} />}
            />
            <Route
              path={ApplicationPaths.LogOut}
              element={<LogoutProcess action={LogoutActions.Logout} />}
            />
            <Route
              path={ApplicationPaths.LogOutCallback}
              element={<LogoutProcess action={LogoutActions.LogoutCallback} />}
            />
            <Route
              path={ApplicationPaths.LoggedOut}
              element={<LogoutProcess action={LogoutActions.LoggedOut} />}
            />
          </Route>
          <Route path="/log-me" element={<GoogleLogMe />} />
          <Route path="app" element={<AppLayout />}>
            <Route index element={<Planoo />} />
            {/*<Route path="Settings" element={<Settings />} />*/}
          </Route>
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        <CookieBanner />
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
